import { render, staticRenderFns } from "./LocationCharges.vue?vue&type=template&id=3183a912&"
import script from "./LocationCharges.vue?vue&type=script&lang=js&"
export * from "./LocationCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports